(function() {
  'use strict';

  angular.module('eclipseApp.internet').config([
    '$stateProvider',
    'brtProvider',
    function($stateProvider, brtProvider) {
      $stateProvider.state('internet', {
        url: '/internet',
        parent: 'app',
        title: 'internet',
        data: {
          service: 'internet'
        },
        resolve: {
          loginProcessCompleted: [
            'authenticationGuardService',
            'signinService',
            function(authenticationGuardService, signinService) {
              return signinService.getLoadingIndicator() ? authenticationGuardService.canActivatePromise() : true;
            }
          ]
        },
        onEnter: [
          '$window','maintenanceService',
          function($window, maintenanceService) {
            $window.sessionStorage.removeItem('agentSelectedOffer');
            maintenanceService.getMaintenance('NAC');


          }
        ],
        views: {
          content: {
            controllerProvider: brtProvider.getControllerProvider('internetCtrl'),
            templateProvider: brtProvider.getTemplateProvider('modules/internet/views/internet.html')
          }
        }
      });
    }
  ]);
})();
